import React from 'react';
import { Outlet } from 'react-router-dom';

const ContractManagement = () => (
  <Outlet />
);

export default ContractManagement;
